import styled from "styled-components";

export const HMenu = styled.button`

display: none;

background-color: red;

`
